//export const DOMAIN = "http://localhost:8080"
export const DOMAIN = "https://wwoo.schachklub-kelheim.de/api"
export const LICHESS_URL = "https://lichess.org/"
export const REGISTER = "https://wwoo.schachklub-kelheim.de/api/callback"

export const ROUND_NAMES = ["1. Runde", "2. Runde", "3. Runde", "4. Runde", "Viertelfinale", "Halbfinale", "Finale/Spiel um Platz 3"]